import { FC, useState, useEffect } from 'react';
import {
  CategoryWrapperProps,
  CategoryItem,
  CategoryMap,
  CategoryCardProps
} from './CategoryWrapper.types';
import Link from 'next/link';
import styles from './CategoryWrapper.module.scss';
import { useLanguage } from '@/hooks/use-language';
import { handleRichText } from '@/utils/handleRichText';
import classNames from 'classnames';
import Icon from '@ant-design/icons';
import ArrowSvg from '../../public/icon/ArrowMiddleOrange.svg';
import WhiteArrowSvg from '../../public/icon/ArrowMiddleWhite.svg';

const categoryMap: CategoryMap = {
  guide: '#0097A9',
  health: '#CCEAEE',
  protection: '#B6E6D8',
  wealth: '#FEE8A0',
  lifestyle: '#FFECDE'
};

const CategoryCard = (props: CategoryCardProps) => {
  const { url, index, title, description, bgImg, bgColor, iconSize, language } = props;
  return (
    <a
      href={`/${language}/blog${url}`}
      key={index}
      className={classNames(styles.category_card, styles[`card_${index}`])}
      style={{ backgroundColor: bgColor }}
    >
      <div className={styles.header_block}>
        <div className={styles.title_block}>
          <h2 className={styles.title}>{title}</h2>
          {description && description?.length > 0 && (
            <div
              className={classNames(styles.rich_text, styles.description)}
              id={'rich_text_wrapper'}
              dangerouslySetInnerHTML={{
                __html: handleRichText(description)
              }}
            ></div>
          )}
        </div>

        <Icon component={ArrowSvg} className={styles.orange_arrow} style={{ fontSize: iconSize }} />
        <Icon
          component={WhiteArrowSvg}
          className={styles.white_arrow}
          style={{ fontSize: iconSize }}
        />
      </div>
      <img className={styles.bg_img} src={bgImg}></img>
    </a>
  );
};

const CategoryWrapper: FC<CategoryWrapperProps> = props => {
  const { data } = props;
  const language = useLanguage();
  const [isMobile, setMobile] = useState(false);
  const newData: CategoryItem[] = [];

  Object.keys(categoryMap).forEach(categoryKey => {
    const curCategory = data?.find(
      category => category?.url === `\/${categoryKey}\/`
    ) as CategoryItem;
    // in EN version ,we don't show guide category
    if (language !== 'en' || categoryKey !== 'guide') {
      newData.push({ ...curCategory, bgColor: categoryMap[categoryKey] });
    }
  });

  useEffect(() => {
    window.addEventListener('resize', () => {
      setMobile(document.body.clientWidth < 768);
    });
    setMobile(document.body.clientWidth < 768);
  }, []);

  return (
    <div
      className={
        newData && newData?.length <= 4 ? styles.four_grid_container : styles.five_grid_container
      }
    >
      {newData?.map((category: CategoryItem, index: number) => (
        <CategoryCard
          index={index + 1}
          key={category?.url}
          url={category?.url || ''}
          title={category?.title}
          bgColor={category.bgColor}
          description={
            category?.category_reference ? category?.category_reference[0]?.description : ''
          }
          bgImg={
            isMobile
              ? category?.category_reference?.[0]?.image_mobile?.url
              : category?.category_reference?.[0]?.image_desktop?.url
          }
          iconSize={isMobile ? '24px' : '40px'}
          language={language || 'zh'}
        />
      ))}
    </div>
  );
};
export default CategoryWrapper;
